const body = document.querySelector('body');

const $refHex = document.querySelectorAll('.ref-hex');
const $modalHex = document.querySelectorAll('.modal-hex');


$refHex.forEach((ref, index) => {
    ref.addEventListener('click', () => {
        $modalHex.forEach((_modal, index) => {
            $modalHex[index].classList.remove('active-modal-hex');
        })
        $modalHex[index].classList.add('active-modal-hex');
        body.style.overflow = 'hidden';
    });
})


$modalHex.forEach((modal, index) => {
  modal.querySelectorAll('.modal-close').forEach( (btn)=>{ btn.addEventListener('click', (ev)=>{
    if ( ev.preventDefault ) ev.preventDefault();
    modal.classList.remove('active-modal-hex');
  }) });
    modal.addEventListener('click', (ev) => {
      if ( ev.preventDefault ) ev.preventDefault();
      if ( ev.stopPropagation ) ev.stopPropagation();
      if ( ev.currentTarget!=ev.target ) return false;
      
        $modalHex[index].classList.remove('active-modal-hex');
        body.style.overflow = 'auto';
    });
})